import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import UserInfo from "@/components/UserInfo";
import EmailSetting from "@/components/EmailSetting";
import AddressList from "@/components/AddressList";
import Pay from "@/components/Pay";
import OrderList from "@/components/OrderList";
import LoveList from "@/components/LoveList";
import Home from "@/components/Home";
import OrderDetail from "../components/OrderDetail";
import GaType from "@/utils/gaType";
import PreviewHome  from "@/components/preview/home";
import h5tomp from "@/components/webtomp.vue";

// import instoreRegistration from "@/components/instoreRegistration";
// import customerForm from "@/components/customerForm";
// import submitSuccess from "@/components/submitSuccess";
// import selectStore from "@/components/selectStore";



const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(Router);

const router = new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (to.meta.keepAlive) {
      let scrollTop = store.state.scrollTop;
      return {x: 0, y: scrollTop}
    }
    return {x: 0, y: 0}
  },
  routes: [
    {
      path: "/",
      name: "home",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
      },
      component: Home,
    },
    {
      path: "/home",
      name: "home",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
      },
      component: Home,
    },
    {
      path: "/preview/home",
      name: "previewhome",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
      },
      component:PreviewHome,
    }, 

    {
      path: "/h5tomp",
      name: "h5tomp",
      meta: {
        title_zh: (_type) => {
          return ``;
        },
        title_en: (_type) => {
          return ``;
        },
      },
      component:h5tomp,
    },
    {
      path: "/preview/custom/:friendly_url",
      name: "previewcustom",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        keepAlive: true,
      },
      component: (resolve) => require(["@/components/preview/custom.vue"], resolve),

    },
    {
      path: "/shopping/:friendly_url",
      name: "shopping",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/PDP"], resolve),

    },
    {
      path: "/fits/:tag",
      name:"fits",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        keepAlive: false,
      },
      component: (resolve) => require(["@/components/fit"], resolve),

    },
    {
      path: "/custom/:friendly_url",
      name: "custom",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        keepAlive: true,
      },
      component: (resolve) => require(["@/components/Custom"], resolve),

    },
    {
      path: "/sets/:friendly_url",
      name: "sets",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        keepAlive: true,
      },
      component: (resolve) => require(["@/components/SetList"], resolve),

    },
    {
      path: "/searchList/:friendly_url",
      name: "searchList",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/SearchList"], resolve),

    },
    {
      path: "/checkout",
      name: "checkout",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/CheckOut"], resolve),

    },
    {
      path: "/checkoutPay",
      name: "checkoutPay",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/CheckOutPay"], resolve),

    },
    {
      path: "/terms",
      name: "terms",
      meta: {
        title_zh: (_type) => {
          return `法律条款 | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `法律条款 | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/Terms"], resolve),

    },
    {
      path: "/privacy",
      name: "privacy",
      meta: `隐私政策 | THOM BROWNE 中国官方网站`,
      component: (resolve) => require(["@/components/Privacy"], resolve),

    },
    {
      path: "/contact-us",
      name: "contact-us",
      meta: {
        title_zh: (_type) => {
          return `联系我们 | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `联系我们 | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/ContactUs"], resolve),

    },
    {
      path: "/returns",
      name: "returns",
      meta: {
        title_zh: (_type) => {
          return `退货与退款 | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `退货与退款 | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/Returns"], resolve),

    },
    {
      path: "/shipping",
      name: "shipping",
      meta: {
        title_zh: (_type) => {
          return `配送政策 | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `配送政策 | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/Shipping"], resolve),

    },
    {
      path: "/login",
      name: "login",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/Login"], resolve),

    },
    {
      path: "/email-register",
      name: "email-register",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/EmailRegister"], resolve),

    },
    {
      path: "/size-chart",
      name: "size-chart",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/SizeChartPage"], resolve),
       
    },
    {
      path: "/stores",
      name: "stores",
      meta: {
        title_zh: (_type) => {
          return `查看附近店铺 | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `查看附近店铺 | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/Store"], resolve),

    },
    {
      path: "/store-detail/:friendlyUrl",
      name: "store-detail",
      meta: {
        title_zh: (_type) => {
          return `查看附近店铺 | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `查看附近店铺 | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/StoreDetail"], resolve),

    },
    {
      path: "/store-list",
      name: "store-list",
      meta: {
        title_zh: (_type) => {
          return `店铺列表 | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `店铺列表 | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/StoreList"], resolve),

    },
    {
      path: "/faq",
      name: "faq",
      meta: {
        title_zh: (_type) => {
          return `常见问题 | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `常见问题 | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/FAQ"], resolve),

    },
    {
      path: "/faq/:value",
      name: "faqValue",
      meta: {
        title_zh: (_type) => {
          return `常见问题 | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `常见问题 | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/FAQ"], resolve),

    },
    {
      path: "/account",
      name: "account",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/Account"], resolve),
      children: [
        {
          name: "user-info",
          path: "user-info",
          components: { menuView: UserInfo },
        },
        {
          name: "email-setting",
          path: "email-setting",
          components: { menuView: EmailSetting },
        },
        {
          name: "address-list",
          path: "address-list",
          components: { menuView: AddressList },
        },
        {
          name: "order-list",
          path: "order-list",
          // component: () => import('@/views/News/index.vue')
          components: { menuView: OrderList },
        },
        {
          name: "pay",
          path: "pay",
          component: { menuView: Pay },
        },
        {
          name: "love-list",
          path: "love-list",
          components: { menuView: LoveList },
        },
        {
          name: "order-detail",
          path: "order-detail",
          components: { menuView: OrderDetail },
        },
      ],
    },
    {
      path: "/test",
      name: "test",
      meta: {
        title_zh: (_type) => {
          return `查看附近店铺 | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `查看附近店铺 | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/test"], resolve),

    },
    {
      path: "/shop-cart",
      name: "shop-cart",
      meta: {
        title_zh: (_type) => {
          return `购物袋 | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `购物袋 | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/ShopBag"], resolve),

    },
    {
      path: "/client-hub/:friendly_url",
      name: "client-hub",
      meta: {
        title_zh: (_type) => {
          return `探索量身定制  | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `探索量身定制  | THOM BROWNE 中国官方网站`;
        },
      },
      
      component: (resolve) => require(["@/components/ClientHub"], resolve),

    },
    {
      path: "/client-hub",
      name: "client-hub",
      meta: {
        title_zh: (_type) => {
          return `探索量身定制 | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `探索量身定制 | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/ClientHub"], resolve),

    },
    {
      path: "/collection/:friendly_url/:content?",
      name: "collection",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/atlas"], resolve),

    },
    {
      path: "/collections/archive/man",
      name: "/collections/archive/man",
      meta: {
        title_zh: (_type) => {
          return `男士时装秀 | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `男士时装秀 | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/atlasList"], resolve),

    },
    {
      path: "/collections/archive/woman",
      name: "/collections/archive/woman",
      meta: {
        title_zh: (_type) => {
          return `女士时装秀 | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `女士时装秀 | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/atlasList"], resolve),

    },
    {
      path: "/article/:friendly_url",
      name: "article",
      meta: {
        title_zh: (_type) => {
          return `探索品牌日志 | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `探索品牌日志 | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/Article"], resolve),

    },
    {
      path: "/journal/archive",
      name: "journal/archive",
      meta: {
        title_zh: (_type) => {
          return `日志档案 | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `日志档案 | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/BlogArchiveList"], resolve),
    },
    {
      path: "/journal",
      name: "journal",
      meta: {
        title_zh: (_type) => {
          return `日志 | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `日志  | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/Journal"], resolve),

    },
    {
      path: "/weChatMoblie",
      name: "weChatMoblie",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/WeChatMoblie"], resolve),
    },
    {
      path: "/product-care/:value?",
      name: "product-care",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/ProductCare"], resolve),
    },

    {
      path: "/about",
      name: "about",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/About"], resolve),
    },
    {
      path:"/instore-registration",
      name:"instoreRegistration",
      meta: {
       title_zh: (_type) => {
         return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
       },
       title_en: (_type) => {
         return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
       },
      },
      component: (resolve) => require(["@/components/instoreRegistration"], resolve),
     },
    {
     path:"/instore-registration/select-store",
     name:"instoreRegistrationselectstore",
     meta: {
      title_zh: (_type) => {
        return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
      },
      title_en: (_type) => {
        return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
      },
     },
     component: (resolve) => require(["@/components/instoreRegistrationSelectStore.vue"], resolve),
    },
    {
      path:"/instore-registration/customer-form",
      name:"instoreRegistrationcustomform",
      meta: {
       title_zh: (_type) => {
         return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
       },
       title_en: (_type) => {
         return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
       },
      },
      component: (resolve) => require(["@/components/instoreRegistrationCustomForm.vue"], resolve),
     },
     {
      path:"/instore-registration/submit-success",
      name:"instoreRegistrationsuccess",
      meta: {
       title_zh: (_type) => {
         return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
       },
       title_en: (_type) => {
         return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
       },
      },
      component: (resolve) => require(["@/components/instoreRegistrationSuccess.vue"], resolve),
     },
     {
      path:"/20th-anniversary",
      name:"20th-anniversary",
      meta: {
       title_zh: (_type) => {
         return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
       },
       title_en: (_type) => {
         return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
       },
      },
      component: (resolve) => require(["@/components/thombrowne20th.vue"], resolve),
     },
     {
      path:"/cs",
      name:"cs",
      meta: {
       title_zh: (_type) => {
         return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
       },
       title_en: (_type) => {
         return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
       },
      },
      component: (resolve) => require(["@/components/cs.vue"], resolve),
     },
     {
      path:"/made-to-measure",
      name:"mtm",
      meta: {
       title_zh: (_type) => {
         return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
       },
       title_en: (_type) => {
         return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
       },
      },
      component: (resolve) => require(["@/components/mtm.vue"], resolve),
     },
     {
      path:"/home-collection",
      name:"homecollection",
      meta: {
       title_zh: (_type) => {
         return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
       },
       title_en: (_type) => {
         return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
       },
      },
      component: (resolve) => require(["@/components/homeCollction.vue"], resolve),
     },
     {
      path: "/404",
      name: "404",
      meta: {
        title_zh: (_type) => {
          return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
        },
        title_en: (_type) => {
          return `THOM BROWNE NEW YORK  | THOM BROWNE 中国官方网站`;
        },
      },
      component: (resolve) => require(["@/components/404"], resolve),

    },
    {
      path: "*",
      redirect: "/404",
    },
  ],
});
function setPathsbysessionStorage(path){
  return new Promise((resolve, reject) => {
    let paths=sessionStorage.getItem('mypaths')?JSON.parse(sessionStorage.getItem('mypaths')) :[]
    paths.push(path);
    paths=paths.slice(-2)
    sessionStorage.setItem('mypaths',JSON.stringify(paths))
  })
};
router.beforeEach((to, from, next) => {

  // if(from.name=='404'&&to.name!='404'){
  //   next()
  //   return;
  // }
  if(to.name=='404'&&to.redirectedFrom){
    
    next({
      path: '/404',
      query: { type: 3,redirect:encodeURIComponent(to.redirectedFrom)},
      replace: true
    })
  }else{
    if (from.path) {

      store.commit("setValue", ["loginOverTo", from.path]);
    }
    if (to.path == "/404") {
  
      GaType.to404();
    }
    next();
  }
 

  
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js